import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("br_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const getToken = () => localStorage.getItem("br_token");

export default api;
